"use client";

import dynamic from "next/dynamic";

export const BlockAccordionCarouselWrapper = dynamic(() =>
  import("./BlockAccordionCarousel").then(mod => mod.BlockAccordionCarousel),
);
